// 滚动动画指令
export default {
  name: 'scroll-animation',
  inserted(el, binding) {
    // 获取动画类名和配置
    const { value } = binding
    const animationClass = value.class || 'animate__fadeInUp'
    const delay = value.delay || 0
    const threshold = value.threshold || 0.3
    const once = value.once !== false // 默认只触发一次
    

    
    // 添加基础animate类和初始隐藏状态
    el.classList.add('animate__animated')
    el.classList.add('scroll-animation-hidden')
    
    
    // 创建Intersection Observer
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 延迟执行动画
            setTimeout(() => {
              // 移除隐藏状态
              el.classList.remove('scroll-animation-hidden')
              
              // 添加动画类触发动画效果
              // 处理多个类名的情况
              if (animationClass.includes(' ')) {
                animationClass.split(' ').forEach(cls => {
                  if (cls.trim()) {
                    el.classList.add(cls.trim())
                  }
                })
              } else {
                el.classList.add(animationClass)
              }
              
              // 动画完成后添加可见状态
              const animationDuration = parseFloat(getComputedStyle(el).animationDuration) * 1000 || 1000
              setTimeout(() => {
                el.classList.add('scroll-animation-visible')
              }, animationDuration)
              
              // 如果只触发一次，则停止观察
              if (once) {
                observer.unobserve(el)
              }
            }, delay)
          } else if (!once) {
            // 如果允许重复触发，离开视口时重置状态
            // 处理多个类名的情况
            if (animationClass.includes(' ')) {
              animationClass.split(' ').forEach(cls => {
                if (cls.trim()) {
                  el.classList.remove(cls.trim())
                }
              })
            } else {
              el.classList.remove(animationClass)
            }
            el.classList.remove('scroll-animation-visible')
            el.classList.add('scroll-animation-hidden')
          }
        })
      },
      {
        threshold: threshold,
        rootMargin: '0px 0px 50px 0px' // 元素进入视口前50px就触发
      }
    )
    
    // 开始观察
    observer.observe(el)
    
    // 保存observer到元素上，用于清理
    el._scrollAnimationObserver = observer
  },
  
  unbind(el) {
    // 清理observer
    if (el._scrollAnimationObserver) {
      el._scrollAnimationObserver.disconnect()
      delete el._scrollAnimationObserver
    }
  }
}